'use strict';

var _extends = Object.assign || function (target) {
  for (var source, i = 1; i < arguments.length; i++) {
    for (var key in source = arguments[i], source) {
      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
  }

  return target;
},
    _createClass = function () {
  function defineProperties(target, props) {
    for (var descriptor, i = 0; i < props.length; i++) {
      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
  };
}(),
    _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _vstui = require('@vitalsource/vstui');

Object.defineProperty(exports, '__esModule', {
  value: !0
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}

function _possibleConstructorReturn(self, call) {
  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
  return call && ('object' == typeof call || 'function' == typeof call) ? call : self;
}

function _inherits(subClass, superClass) {
  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
}

var Group = function (_PureComponent) {
  function Group() {
    return _classCallCheck(this, Group), _possibleConstructorReturn(this, (Group.__proto__ || Object.getPrototypeOf(Group)).apply(this, arguments));
  }

  return _inherits(Group, _PureComponent), _createClass(Group, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_vstui.Icon, _extends({}, this.props, {
        height: 16,
        width: 22
      }), _react2.default.createElement('path', {
        d: 'M19.123 9.02c3.088 1.04 2.874 1.883 2.874 2.822v1.157h-5.068c-.219-1.256-1.094-2.386-4.212-3.53.324-.146.702-.295 1.16-.45.461-.155.887-.335 1.147-.71-.736-.812-1.272-2.122-1.272-3.347 0-1.963 1.231-2.962 2.75-2.962 1.517 0 2.749.998 2.749 2.962 0 1.226-.536 2.537-1.274 3.348.261.375.686.554 1.146.71zm-7.309 1.19c4.494 1.515 4.181 2.74 4.181 4.105V16H.002v-2c-.015-1.241.042-2.393 4.184-3.79.67-.226 1.288-.487 1.668-1.033-1.07-1.182-1.85-3.088-1.85-4.869C4.003 1.453 5.793 0 8.002 0c2.21 0 4 1.453 4 4.308 0 1.783-.78 3.69-1.851 4.872.38.544.996.804 1.665 1.03z'
      }));
    }
  }]), Group;
}(_react.PureComponent);

Group.displayName = 'Group', Group.vstuiName = 'Icon', exports.default = Group;